import React from "react";
import { UserProfileContainerStyled } from "./styled";
import { withRouter } from "navigations/withRouter";
import { scrollToTopPageFN } from "utils/functions/scrollTopPage";
import { portalService } from "apiServices";
import * as XLSX from "xlsx";
import moment from "moment";
import "moment-timezone";
import { AlertControl } from "components/Modals/Alert";
import { toast } from "react-toastify";
import { MdHistory } from "react-icons/md";
import { UserPointHistoryContainer } from "./Modals";
import { Displays, Modals, Inputs, Tables } from "components";
import {
  parseFilterQuery,
  syncFilterUrlQuery,
} from "utils/functions/filterQuery";

const FILTER_FIELDS = [
  "name",
  "phone_number",
  "cu_id",
  "user_id",
  "start_date",
  "end_date",
];

class UserProfileContainer extends React.Component {
  state = {
    isLoading: true,
    pagination: null,
    perPage: 10,
    // เปลี่ยน key เพื่อบังคับสร้าง InputFilter ใหม่ตอนกดล้างค่า
    filterKey: 0,
    ...parseFilterQuery(this.props.router.location.search, FILTER_FIELDS),
  };

  componentDidMount() {
    const { filterQuery, currentPage } = this.state;
    scrollToTopPageFN();
    this.handleJoinQuery(filterQuery, currentPage);
  }

  fetchData = async (stringQuery) => {
    let res = await portalService.GET_CUSTOMER_LIST(stringQuery);
    if (res && res.status === 200) {
      this.setState({
        data: res.data.docs,
        isLoading: false,
        isBgLoading: false,
        pagination: {
          last_page: res.data.totalPages,
          current_page: res.data.page,
        },
      });
    } else {
      this.setState({ isLoading: false, isBgLoading: false });
    }
  };

  handleFilterKeyword = (e) => {
    const parsedQuery = parseFilterQuery(e, FILTER_FIELDS);
    this.setState({ ...parsedQuery });
    this.handleJoinQuery(parsedQuery.filterQuery, 1);
  };

  handleClearFilter = () => {
    this.setState((prevState) => ({
      ...parseFilterQuery("", FILTER_FIELDS),
      filterKey: prevState.filterKey + 1,
    }));
    this.handleJoinQuery("", 1);
  };

  handlePageClick = (e) => {
    const { filterQuery } = this.state;
    this.handleJoinQuery(filterQuery, e.selected + 1);
  };

  handleJoinQuery = (query, page) => {
    const { perPage } = this.state;
    let joinQuery = query
      ? `${query}&limit=${perPage}&page=${page}`
      : `?limit=${perPage}&page=${page}`;
    this.setState({
      isLoading: true,
      currentPage: page,
    });
    syncFilterUrlQuery(this.props.router, query, page);
    this.fetchData(joinQuery);
  };

  handleReloadCurrentPage = () => {
    const { filterQuery, currentPage } = this.state;
    this.handleJoinQuery(filterQuery, currentPage);
  };

  handleExport = async () => {
    const { filterQuery } = this.state;
    this.setState({
      isBgLoading: true,
    });
    let joinQuery = filterQuery
      ? `${filterQuery}&pagination=false`
      : `?pagination=false`;
    let res = await portalService.GET_CUSTOMER_LIST(joinQuery);
    if (res && res.status === 200) {
      var wb = XLSX.utils.book_new();
      var ws_name = "SheetJS";
      /* make worksheet */
      var ws_data = res.data.docs.reduce((result, e, i) => {
        result.push([
          i + 1,
          `${e.firstname} ${e.lastname}`,
          e.phone_number,
          e.address,
          moment(e.created_at).tz("Asia/Bangkok").format("DD/MM/YYYY HH:mm:ss"),
          e.cu_id,
          e.email,
          e.user_id,
          e.wallet_detail?.point,
        ]);
        return result;
      }, []);
      ws_data.splice(0, 0, [
        "No",
        "Name",
        "Tel",
        "Address",
        "Created at",
        "CU code",
        "Email",
        "User ID",
        "Point",
      ]);
      var ws = XLSX.utils.aoa_to_sheet(ws_data);
      var wscols = [
        { wch: 5 },
        { wch: 35 },
        { wch: 15 },
        { wch: 100 },
        { wch: 25 },
        { wch: 15 },
        { wch: 15 },
        { wch: 15 },
        { wch: 15 },
        { wch: 15 },
      ];
      ws["!cols"] = wscols;
      /* Add the worksheet to the workbook */
      XLSX.utils.book_append_sheet(wb, ws, ws_name);
      XLSX.writeFile(
        wb,
        `Customer report ${moment()
          .tz("Asia/Bangkok")
          .format("DD/MM/YYYY")}.xlsx`
      );
      this.setState({
        isBgLoading: false,
      });
    }
  };

  handleDelete = (e) => {
    AlertControl.show({
      title: "ยืนยันการลบ",
      description: "คุณต้องการจะลบใช่หรือไม่",
      btnLabel1: "ยกเลิก",
      btnLabel2: "ยืนยัน",
      onEvent2: async () => {
        this.setState({ isBgLoading: true });
        let resArr = await Promise.all(
          e.map((f) => {
            return new Promise(async (resolve) => {
              let res = await portalService.DELETE_CUSTOMER(f._id);
              if (res && res.status === 200) {
                resolve(res);
              }
            });
          })
        );
        if (resArr) {
          this.setState({
            isBgLoading: false,
          });
          this.handleReloadCurrentPage();
          toast.success("ลบสำเร็จ");
        }
      },
    });
  };

  handleClickPointHistory = (e) => {
    this.setState({
      renderModal: (
        <UserPointHistoryContainer
          cusID={e._id}
          point={e?.wallet_detail?.point}
        />
      ),
    });
  };

  handleCloseModal = () => {
    this.setState({
      renderModal: false,
    });
  };

  render() {
    const {
      isLoading,
      isBgLoading,
      pagination,
      data,
      renderModal,
      filterValues,
      filterKey,
    } = this.state;
    return (
      <UserProfileContainerStyled>
        <Displays.BGLoading visible={isBgLoading} />
        <div className="filter_layout">
          <Inputs.InputFilter
            key={filterKey}
            theme_standard_input_filter
            dataFilter={dataFilter(filterValues)}
            btnLabel="ค้นหา"
            clearLabel="ล้างค่า"
            onQueryFilter={this.handleFilterKeyword}
            onClear={this.handleClearFilter}
            onExport={this.handleExport}
          />
        </div>
        {isLoading ? (
          <Displays.Loading theme_standard_loading heightLayout="336px" />
        ) : (
          <Tables.Standard
            isSelect
            columns={columns({
              handleClickPointHistory: this.handleClickPointHistory,
            })}
            data={data}
            showPagination
            pagination={pagination}
            onDelete={this.handleDelete}
            handlePageClick={this.handlePageClick}
          />
        )}
        <Modals.BodyEmpty
          isShowModal={renderModal}
          onCloseModal={this.handleCloseModal}
        >
          {renderModal}
        </Modals.BodyEmpty>
      </UserProfileContainerStyled>
    );
  }
}

const dataFilter = (filterValues) => [
  {
    accessor: "name",
    length: "250px",
    filter: {
      fieldQuery: "name",
      type: "text",
      defaultValue: filterValues.name,
      label: "Name : ",
      placeholder: "ชื่อ / นามสกุล",
    },
  },
  {
    accessor: "phone_number",
    length: "200px",
    filter: {
      fieldQuery: "phone_number",
      type: "text",
      defaultValue: filterValues.phone_number,
      label: "Tel : ",
      placeholder: "เบอร์โทร",
    },
  },
  {
    accessor: "cu_id",
    length: "200px",
    filter: {
      fieldQuery: "cu_id",
      type: "text",
      defaultValue: filterValues.cu_id,
      label: "CU code : ",
      placeholder: "CU code",
    },
  },
  {
    accessor: "user_id",
    length: "200px",
    filter: {
      fieldQuery: "user_id",
      type: "text",
      defaultValue: filterValues.user_id,
      label: "User ID : ",
      placeholder: "User ID",
    },
  },
  {
    accessor: "date",
    filter: {
      fieldQuery: "date",
      type: "dateRank",
      defaultStartValue: filterValues.start_date,
      defaultEndValue: filterValues.end_date,
      label: "Date Range : ",
    },
  },
];

const columns = ({ handleClickPointHistory }) => [
  {
    Header: <div style={{ textAlign: "left" }}>Name</div>,
    accessor: "fistname",
    Cell: (props) => (
      <div>
        {`${props.row.original.firstname} ${props.row.original.lastname}`}
      </div>
    ),
  },
  {
    Header: <div style={{ textAlign: "left" }}>Tel</div>,
    accessor: "phone_number",
  },
  {
    Header: <div style={{ textAlign: "left" }}>Address</div>,
    accessor: "address",
  },
  {
    Header: <div style={{ textAlign: "left" }}>Created at</div>,
    accessor: "created_at",
    Cell: (props) =>
      moment(props.value).tz("Asia/Bangkok").format("DD/MM/YYYY HH:mm:ss"),
  },
  {
    Header: <div style={{ textAlign: "left" }}>CU code</div>,
    accessor: "cu_id",
  },
  {
    Header: <div style={{ textAlign: "left" }}>Email</div>,
    accessor: "email",
  },
  {
    Header: <div style={{ textAlign: "left" }}>User ID</div>,
    accessor: "user_id",
    Cell: (props) => <div style={{ textAlign: "left" }}>{props.value}</div>,
  },
  {
    Header: <div style={{ textAlign: "left" }}>Point</div>,
    accessor: "wallet_detail",
    Cell: (props) => (
      <div style={{ textAlign: "left" }}>{props.value?.point}</div>
    ),
  },
  {
    Header: "Action",
    accessor: "action",
    Cell: (props) => (
      <div
        style={{ textAlign: "right" }}
        onClick={() => handleClickPointHistory(props.row.original)}
      >
        <MdHistory size={24} />
      </div>
    ),
  },
];

export default withRouter(UserProfileContainer);
